/**
 * 滚动位置保持指令（比例存储版）
 *
 * 存储格式：{ top: number, height: number }
 *   - top：记录时的 el.scrollTop（绝对滚动位置）
 *   - height：记录时的 el.scrollHeight（总可滚动高度）
 *
 * 恢复时按比例计算：el.scrollTop = el.scrollHeight × (top / height)
 * 避免因容器高度变化导致回退后位置偏差。
 *
 * @usage
 *   <div v-scroll-top="scrollTop">
 * @param {Object} scrollTop 滚动位置对象 ref
 */

export default {
  mounted(el, binding) {
    const rawValue = binding.value
    const isObject = rawValue && typeof rawValue === 'object' && 'ref' in rawValue
    const targetRef = isObject ? rawValue.ref : rawValue

    if (!targetRef || typeof targetRef !== 'object') {
      console.warn('[v-scroll-top] 用法: v-scroll-top="scrollTop，请确保scrollTop是一个ref的Object"')
      return
    }

    let isRestoring = false

    const onScroll = () => {
      if (isRestoring) return
      // 记录滚动位置 + 总高度，用于后续按比例恢复
      targetRef.top = el.scrollTop
      targetRef.height = el.scrollHeight
    }

    el.addEventListener('scroll', onScroll)

    // 保存引用
    el.__scrollCleanup__ = () => {
      el.removeEventListener('scroll', onScroll)
    }

    /**
     * 按比例恢复滚动位置
     * 用记录的 top/height 比例 × 当前 scrollHeight，确保视觉位置一致
     */
    el.__scrollRestore__ = () => {
      const { top, height } = targetRef
      if (top > 0 && height > 0) {
        isRestoring = true
        // 按比例恢复：当前总高度 × 原比例
        el.scrollTop = el.scrollHeight * (top / height)
        setTimeout(() => { isRestoring = false }, 50)
      }
    }
  },

  unmounted(el) {
    el.__scrollCleanup__?.()
    delete el.__scrollCleanup__
    delete el.__scrollRestore__
  }
}
